import { create } from "zustand";

const THEME_KEY = "theme";
export enum ETheme {
  DARK = "dark",
  LIGHT = "light",
}

interface IGlobalPreferencesStore {
  theme: ETheme;
  setTheme: (theme: ETheme) => void;
}

const getInitialTheme = (): ETheme => {
  const savedTheme = localStorage.getItem(THEME_KEY);

  return savedTheme === ETheme.DARK ? ETheme.DARK : ETheme.LIGHT;
};

const useGlobalPreferencesStore = create<IGlobalPreferencesStore>((set) => ({
  theme: getInitialTheme(),

  setTheme: (theme) => {
    localStorage.setItem(THEME_KEY, theme);
    set({ theme });
  },
}));

export default useGlobalPreferencesStore;
